/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureContext {
    getFixupPrototypeFunction() { return TagPostureContext.fixupPrototype; }

    static newInstance(model: Partial<TagPostureContext>): TagPostureContext {
        let obj = Object.assign(new TagPostureContext(), model);
        TagPostureContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureContext>): TagPostureContext {
        if (!model) return null;
        return TagPostureContext.newInstance(<TagPostureContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureContext) {
        if (!obj) return;

        models.TagPostureContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureContext): boolean {
        Object.setPrototypeOf(obj, TagPostureContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter) {
            models.AccountFilters.fixupPrototype(this.filter);
        }
    }

    filter: models.AccountFilters;

    /**
     * Only return postures for the selected baseline
     */
    baseline_id: string;

    /**
     * Resource categories to filter (all if missing)
     */
    resource_categories: Array<string>;

    /**
     * Resource components to filter (all if missing)
     */
    resource_components: Array<string>;

    /**
     * Resources types to filter (all if missing)
     */
    resource_types: Array<string>;

    /**
     * Resources to filter (all if missing)
     */
    resources: Array<string>;

    /**
     * Whether to only return resources that support remediation
     */
    supports_remediation_only: boolean;

    /**
     * Text query for tag postures
     */
    text_query: string;

    /**
     * Workload Id
     */
    workload_id: string;

    /**
     * Whether to only return billable/non billable resources)
     */
    is_billable: Array<boolean>;

    /**
     * Tag key to filter resources by, used to evaluate governance coverage for a specific tag like 'owner' or 'environment'.
     */
    tag_key: string;

}
